<template>
  <v-container fluid fill-height>
    <v-layout align-start justify-center>
      <!-- RESET PASSWORD -->
      <v-dialog v-model="showResetPassword" persistent max-width="390">
        <v-card>
          <v-card-title class="headline">
            <font-awesome-icon
              class="mr-2"
              :style="{ color: '#424242' }"
              size="lg"
              :icon="['fal', 'undo-alt']"
            />
            Restablecer Contraseña
          </v-card-title>
          <v-form v-model="valid" ref="formRSTP" lazy-validation>
            <v-card-text>
              <v-flex class="body-2 grey--text text--darken-2">
                Usando el Email con el cual esta registrado puede restablecer la
                contraseña.
              </v-flex>
              <v-text-field
                v-model="emailToResetPassword"
                prepend-icon="person"
                name="login"
                label="Email"
                type="text"
                color="#466EA5"
                required
                :rules="emailRules"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <!-- v-if="showCancelBtn" -->
              <v-btn
                class="text-capitalize"
                color="red darken-1"
                dark
                depressed
                @click="cancel"
              >
                <font-awesome-icon
                  class="mr-2"
                  :style="{ color: '#FFFFFF' }"
                  size="lg"
                  :icon="['fal', 'times-circle']"
                />
                Cancelar
              </v-btn>

              <!-- v-if="showSendBtn" -->
              <v-btn
                class="text-capitalize"
                color="#466EA5"
                depressed
                :dark="valid"
                :disabled="!valid"
                @click="accept"
              >
                <font-awesome-icon
                  class="mr-2"
                  :style="{ color: '#FFFFFF' }"
                  size="lg"
                  :icon="['fal', 'paper-plane']"
                />
                Enviar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <!--  -->
      <v-flex xs12 sm8 md4>
        <v-flex>
          <v-img
            :src="require('../assets/logo-color-experis.svg')"
            contain
            height="80"
          ></v-img>
        </v-flex>
        <v-flex class="text-xs-center" py-5>
          <h2>Bienvenido a CTG - Control Timing Guide</h2>
        </v-flex>
        <!-- <v-flex class="text-xs-center">
          <font-awesome-icon
            :style="{ color: '#C46D24' }"
            size="10x"
            :icon="['fas', 'exclamation-circle']"
          />
          <h3 class="mt-5">Estamos realizando un nuevo despliegue. En unas horas se notificará al correo electrónico la disponibilidad de la plataforma. Gracias por su comprensión.</h3>
        </v-flex> -->
        <v-flex class="text-xs-center">
          <h3>Ingrese sus credenciales para acceder</h3>
        </v-flex>
        <v-card class="elevation-1 mx-5 mt-3">
          <v-toolbar dark color="#C46D24" flat>
            <v-toolbar-title class="px-3">
              <v-flex d-inline-flex align-center>
                <h1>CTG</h1>
                <h4 class="pl-3">Autenticación</h4>
              </v-flex>
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text class="px-5">
            <v-form>
              <v-text-field
                v-model="data.user"
                prepend-icon="person"
                name="login"
                label="Email"
                type="text"
                color="#466EA5"
                clearable
                required
                :rules="emailRules"
                @input="loginData(data)"
              >
              </v-text-field>
              <v-text-field
                v-model="data.password"
                id="password"
                prepend-icon="lock"
                name="password"
                label="Contraseña"
                color="#466EA5"
                clearable
                :append-icon="showPass ? 'visibility' : 'visibility_off'"
                :type="showPass ? 'text' : 'password'"
                @click:append="showPass = !showPass"
                @input="loginData(data)"
              >
              </v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions class="px-5 pb-4">
            <v-spacer></v-spacer>
            <v-btn class="text-capitalize" color="#466EA5" dark @click="signin">
              <font-awesome-icon
                class="mr-2"
                :style="{ color: '#FFFFFF' }"
                size="lg"
                :icon="['fal', 'sign-in']"
              />
              Iniciar Sesión
            </v-btn>
          </v-card-actions>
          <v-divider class="mx-5"></v-divider>
          <v-flex class="text-xs-center" py-2>
            <v-btn
              flat
              small
              color="grey darken-3"
              class="text-capitalize caption"
              @click="resetPasswordOpen"
            >
              <font-awesome-icon
                class="mr-2"
                :style="{ color: '#424242' }"
                size="lg"
                :icon="['fal', 'undo-alt']"
              />
              Restablecer Contraseña
            </v-btn>
          </v-flex>
        </v-card>
        <v-flex class="text-xs-center" mt-5>
          <v-flex mb-5>
            <h6>
              Para garantizar tu experiencia te recomendamos usar los siguientes
              navegadores en su <b>última versión</b>:
            </h6>
            <v-flex d-flex mt-3 px-5>
              <v-flex>
                <font-awesome-icon
                  :style="{ color: '#BDBDBD' }"
                  size="2x"
                  :icon="['fab', 'chrome']"
                />
                <h6>Chrome</h6>
              </v-flex>
              <v-flex>
                <font-awesome-icon
                  :style="{ color: '#BDBDBD' }"
                  size="2x"
                  :icon="['fab', 'firefox']"
                />
                <h6>Firefox</h6>
              </v-flex>
              <v-flex>
                <font-awesome-icon
                  :style="{ color: '#BDBDBD' }"
                  size="2x"
                  :icon="['fab', 'safari']"
                />
                <h6>Safari 10+</h6>
              </v-flex>
              <v-flex>
                <font-awesome-icon
                  :style="{ color: '#BDBDBD' }"
                  size="2x"
                  :icon="['fab', 'edge']"
                />
                <h6>Edge</h6>
              </v-flex>
            </v-flex>
          </v-flex>
          <h5>Todos los derechos reservados <b>ManpowerGroup®</b></h5>
          <h5>Versión {{ versionApp }}</h5>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      showPass: false,
      valid: false,
      showResetPassword: false,
      emailToResetPassword: "",
      data: {
        user: "",
        password: ""
      },
      emailRules: [
        v => !!v || "El Email es requerido",
        v =>
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "El Email debe ser válido"
      ]
    };
  },
  computed: {
    ...mapGetters(["versionApp"])
  },
  methods: {
    ...mapActions(["resetPassword", "signin", "loginData"]),
    accept() {
      if (this.$refs.formRSTP.validate()) {
        console.log("SEND RSTP!");
        this.resetPassword(this.emailToResetPassword);
        this.showResetPassword = false;
        this.emailToResetPassword = "";
      } else console.log("VERIFY FORM!");
    },
    cancel() {
      this.showResetPassword = false;
    },
    resetPasswordOpen() {
      this.showResetPassword = true;
    }
  }
};
</script>

<style lang="stylus" scoped>
h1
  color white

h2
  color #466EA5
  font-size 21px

h3
  font-size 16px
  font-weight 500

h4
  color white

h5
  font-size 14px
  font-weight 500
  color #757575

h6
  font-size 10px
  font-weight 400
  color #757575
</style>
